module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "overlay"
    },
    on: {
      "click": _vm.overlayClick
    }
  }, [_c('div', {
    attrs: {
      "id": "textbox"
    }
  }, [_c('div', {
    staticClass: "handle top"
  }), _vm._v(" "), _c('div', {
    staticClass: "handle bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "handle left"
  }), _vm._v(" "), _c('div', {
    staticClass: "handle right"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "close-text"
    },
    on: {
      "click": _vm.closeClick
    }
  }, [_vm._v("close")]), _vm._v(" "), (_vm.main.text.acf.pdf) ? _c('div', {
    attrs: {
      "id": "download"
    }
  }, [_vm._v("("), _c('a', {
    attrs: {
      "href": _vm.main.text.acf.pdf.url,
      "target": "_blank"
    }
  }, [_vm._v("download/print")]), _vm._v(")")]) : _vm._e(), _vm._v(" "), _c('h1'), _vm._v(" "), _c('article', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.main.text.acf.text)
    }
  }), _vm._v(" "), _vm._l((_vm.main.text.acf.links), function(link) {
    return _c('span', {
      staticClass: "link-container"
    }, [_c('span', [_vm._v("("), _c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.title))]), _vm._v(")")])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6eed1756!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/txt.vue
// module id = 475
// module chunks = 2